import React from "react";
import { Select, SelectProps } from "@mantine/core";

import styles from "@scss/custom-components/form-fields-dropdowns.module.scss";

interface CustomSelectProps extends SelectProps {}

export const CustomSelect: React.FC<CustomSelectProps> = ({
  variant = "default",
  classNames = {},
  ...props
}) => {
  const variantDropdownClasses: Record<string, string> = {
    default: styles["dropdown--default"],
    dark: styles["dropdown--dark"],
    darker: styles["dropdown--darker"],
    sky: styles["dropdown--sky"],
  };

  const customDropdownClass = variantDropdownClasses[variant] || "";

  return (
    <Select
      variant={variant}
      classNames={{
        ...classNames,
        dropdown: customDropdownClass,
        options: styles.options,
        option: styles.option,
      }}
      {...props}
    />
  );
};
